<ng-container [ngSwitch]="['b500'] | getProductName">
  <ng-container *ngSwitchCase="'b500'">
    <h1 mat-dialog-title class="text sign-out-h1">{{ 'Modal_Sign_Out' | t }}</h1>
    <div mat-dialog-actions class="text sign-out-button-container">
      <button mat-button (click)="signOutNoClick()">{{ 'No' | t }}</button>
      <button mat-button cdkFocusInitial (click)="signOutYesClick()">{{ 'Yes' | t }}</button>
    </div>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <div class="info-icon">
      <image-loader-utils url="info" extraClasses="info-icon"></image-loader-utils>
    </div>
    <div class="header-container">{{ 'SignOut_Text1' | t }}</div>

    <div class="logout-info-container">
      {{ 'SignOut_Text2' | t }}
    </div>
    <div class="btn colored green save-changes-button confirm-button" (click)="signOutNoClick()">
      <div class="btn-text">
        {{ 'SignOut_Text3' | t }}

        <!-- {{"Yes" | t}} -->
      </div>
    </div>
    <div class="white-black-text confirm-button" (click)="signOutYesClick()">
      <div class="btn-text">
        {{ 'SignOut_Text4' | t }}

        <!-- {{"No" | t}} -->
      </div>
    </div>
  </ng-container>
</ng-container>
